<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('administration.exchange_rate.exchange_rate') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('administration.exchange_rate.exchange_rate'),
            active: true
          }
        ]"
      />
    </div>
    <div class="row">
      <div class="col-lg-3 col-md-5 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <form-create
              @success_create="fetchData"
              :edit="edit_data"
              @success_update="edit_data = ''"
              @cancel="fetchData"
            ></form-create>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-lg-9 col-md-7 col-sm-12">
        <ts-card>
          <ts-card-wrapper class="d-flex justify-content-end">
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              style="width: 300px"
              class="mr-2"
            />
            <ts-button
              outline
              v-tooltip="$t('filter')"
              @click.prevent="visible = true"
            >
              <i class="fa fa-filter"></i>
            </ts-button>
          </ts-card-wrapper>
          <div class="overflow-auto">
            <ts-table
              :columns="columns"
              :records="resources"
              :loading="loading"
            >
              <template v-slot="{ record }">
                <td class="ts-whitespace-no-wrap">
                  {{
                    record.branch !== null ? record.branch.branch_name_en : ''
                  }}
                </td>
                <td class="ts-whitespace-no-wrap">{{ record.value_date }}</td>
                <td class="ts-whitespace-no-wrap">
                  {{
                    record.currency !== null
                      ? record.currency.currency_code
                      : ''
                  }}
                </td>
                <td class="ts-whitespace-no-wrap">
                  {{ record.exchange_rate }}
                </td>
                <td class="ts-whitespace-no-wrap">{{ record.exchange_buy }}</td>
                <td class="ts-whitespace-no-wrap">
                  {{ record.exchange_sell }}
                </td>
                <td class="text-center">
                  <a
                    href="#"
                    v-tooltip="$t('edit')"
                    class="text-primary mr-2"
                    @click.prevent="edit(record)"
                  >
                    <i class="fas fa-edit"></i>
                  </a>
                  <a
                    href="#"
                    v-tooltip="$t('delete')"
                    class="text-danger"
                    @click.prevent="destroy(record.id)"
                  >
                    <i class="fas fa-trash"></i>
                  </a>
                </td>
              </template>
            </ts-table>
          </div>
          <ts-card-wrapper class="d-flex justify-content-end p-15">
            <ts-pagination v-model="pagination" @navigate="fetchData">
            </ts-pagination>
          </ts-card-wrapper>
        </ts-card>
        <a-drawer
          :title="$t('filter')"
          placement="right"
          :closable="false"
          :visible="visible"
          @close="() => (visible = false)"
          :zIndex="1020"
          width="300px"
        >
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <a-select
                  style="width: 257px"
                  v-model="branch_id"
                  :options="branchs"
                  showSearch
                  mode="multiple"
                  :filterOption="
                    (input, option) =>
                      option.componentOptions.children[0].text
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                  "
                  :maxTagCount="1"
                  :maxTagTextLength="17"
                  :placeholder="$t('all')"
                >
                </a-select>
              </div>
            </div>
          </div>
        </a-drawer>
      </div>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FormCreate from './form.vue'

export default {
  components: {
    FormCreate
  },
  name: 'exchange-rate',
  props: ['editData'],
  data () {
    return {
      edit_data: this.editData,
      loading: false,
      visible: false,
      branchs: []
    }
  },
  created () {
    this.branch_id = [this.$store.state.authUser.default_branch_id]
    this.fetchData()
    this.getBranch()
  },
  computed: {
    ...mapState('exchangeRate', ['resources', 'pagination']),
    search: {
      get () {
        return this.$store.state.exchangeRate.search
      },
      set (newVal) {
        this.$store.commit('exchangeRate/SET_SEARCH', newVal)
        this.$store.commit('exchangeRate/RESET_CURRENT_PAGE')
      }
    },
    branch_id: {
      get () {
        return this.$store.state.exchangeRate.branch_id
      },
      set (newValue) {
        this.$store.commit('exchangeRate/SET_BRANCH_ID', newValue)
      }
    },
    columns () {
      return [
        { name: this.$t('administration.exchange_rate.branch') },
        { name: this.$t('administration.exchange_rate.date') },
        { name: this.$t('administration.exchange_rate.currency') },
        { name: this.$t('administration.exchange_rate.exchange_rate') },
        { name: this.$t('administration.exchange_rate.buy_rate') },
        { name: this.$t('administration.exchange_rate.sell_rate') },
        {
          name: this.$t('administration.exchange_rate.actions'),
          style: 'width: 1px; text-align:center'
        }
      ]
    }
  },
  methods: {
    fetchData (attributes) {
      this.loading = true

      this.$store
        .dispatch(
          'exchangeRate/fetch',
          Object.assign(
            {
              branch_id: this.branch_id
            },
            { ...attributes }
          )
        )
        .then(() => (this.loading = false))
        .catch(error => {
          this.$toasted.error(error.message)
          this.loading = false
        })
    },
    getBranch () {
      this.$store
        .dispatch('user/getBranch', {
          filter: {
            user_branches: true
          }
        })
        .then(response => {
          this.branchs = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
        })
    },
    edit (data) {
      this.edit_data = data
      this.$router.push(`/exchange-rates/${data.id}`)
    },

    async destroy (id) {
      if (await this.$confirmModal.danger(this.$t('are_you_sure_to_delete'))) {
        this.$store
          .dispatch('exchangeRate/delete', id)
          .then(response => {
            this.$toasted.success(response.message)
            this.fetchData()
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
      }
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search })
    }, 500),
    branch_id: debounce(function (value) {
      this.fetchData({ branch_id: value })
    }, 500)
  },
  beforeRouteLeave (to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'exchange-rate-create') {
      this.$store.commit('exchangeRate/RESET_STATE')
    }
    next()
  }
}
</script>
